import { render, staticRenderFns } from "./template-mbti.vue?vue&type=template&id=ff311be6&scoped=true&"
import script from "./template-mbti.vue?vue&type=script&lang=js&"
export * from "./template-mbti.vue?vue&type=script&lang=js&"
import style0 from "./template-mbti.vue?vue&type=style&index=0&id=ff311be6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff311be6",
  null
  
)

export default component.exports